String.prototype.like = function (string: string, caseSentitive?: boolean) {
	if (caseSentitive) return this === string || this.includes(string);
	return this.toLowerCase() === string.toLowerCase() || this.toLowerCase().includes(string.toLowerCase());
};

export {};
